import React, { useState } from 'react';
import axios from 'axios';

const SelfCheckin = () => {
  const [code, setCode] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code) {
        setMsg('❌ Vui lòng nhập mã số của bạn');
        return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('employee_code', code);
    if (file) {
        formData.append('avatar', file);
    }

    try {
        const res = await axios.post('/api/self-checkin', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        setMsg('✅ ' + res.data.message);
        // Reset form
        setCode('');
        setFile(null);
        setPreview(null);
    } catch (err) {
        setMsg('❌ ' + (err.response?.data?.message || 'Lỗi kết nối'));
    } finally {
        setLoading(false);
    }
  };

  return (
    <div style={{ 
        minHeight: '100vh', display: 'flex', flexDirection: 'column', 
        alignItems: 'center', justifyContent: 'center', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: 20, fontFamily: 'Arial'
    }}>
      <div style={{ 
          background: 'white', padding: 30, borderRadius: 20, 
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)', width: '100%', maxWidth: '400px',
          textAlign: 'center'
      }}>
        <h1 style={{ color: '#333', marginBottom: 5 }}>CHECK IN</h1>
        <h3 style={{ color: '#e67e22', marginTop: 0, textTransform: 'uppercase' }}>Nhận Quà May Mắn 🎁</h3>

        <form onSubmit={handleSubmit} style={{ marginTop: 20 }}>
            
            {/* INPUT MÃ SỐ */}
            <div style={{ marginBottom: 20, textAlign: 'left' }}>
                <label style={{fontWeight:'bold', display:'block', marginBottom: 5}}>Mã Số / SĐT (*)</label>
                <input 
                    type="text" 
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Nhập mã của bạn..."
                    style={{
                        width: '100%', padding: '12px', fontSize: 16, 
                        borderRadius: 8, border: '1px solid #ddd', boxSizing: 'border-box'
                    }}
                />
            </div>

            {/* INPUT ẢNH */}
            <div style={{ marginBottom: 20, textAlign: 'left' }}>
                <label style={{fontWeight:'bold', display:'block', marginBottom: 5}}>Ảnh đại diện (Tùy chọn)</label>
                
                <div style={{
                    border: '2px dashed #ccc', borderRadius: 10, padding: 20,
                    display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer',
                    background: '#f9f9f9'
                }} onClick={() => document.getElementById('avatarInput').click()}>
                    
                    {preview ? (
                        <img src={preview} alt="Preview" style={{width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', border: '2px solid #fff', boxShadow: '0 2px 5px rgba(0,0,0,0.2)'}} />
                    ) : (
                        <div style={{fontSize: 40}}>📸</div>
                    )}
                    <p style={{margin: '10px 0 0', fontSize: 14, color: '#666'}}>
                        {preview ? 'Chạm để đổi ảnh' : 'Chụp ảnh hoặc Chọn từ thư viện'}
                    </p>
                </div>

                <input 
                    id="avatarInput"
                    type="file" 
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />
            </div>

            {/* MESSAGE */}
            {msg && <div style={{ 
                marginBottom: 20, padding: 10, borderRadius: 5, fontWeight: 'bold',
                background: msg.includes('✅') ? '#d4edda' : '#f8d7da',
                color: msg.includes('✅') ? '#155724' : '#721c24'
            }}>{msg}</div>}

            {/* BUTTON */}
            <button 
                type="submit"
                disabled={loading}
                style={{
                    width: '100%', padding: '15px', fontSize: 18, fontWeight: 'bold',
                    background: loading ? '#95a5a6' : '#8e44ad', color: 'white',
                    border: 'none', borderRadius: 30, cursor: loading ? 'not-allowed' : 'pointer',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)', transition: 'background 0.3s'
                }}
            >
                {loading ? 'ĐANG GỬI...' : 'GỬI THÔNG TIN 🚀'}
            </button>
        </form>

        <p style={{marginTop: 20, fontSize: 12, color: '#888'}}>
            Hệ thống quay số Gosatech
        </p>
      </div>
    </div>
  );
};

export default SelfCheckin;
